module.exports = __webpack_public_path__ + "img/2.9017ce00.png";